import {Dispatch, SetStateAction} from "react";

interface PropsType {
    tab: string
    setTab: Dispatch<SetStateAction<string>>
    menuTitleText: string
}

export default function TabNav({tab, setTab, menuTitleText}: PropsType) {
    const clickTab = (str: string) => {
        setTab(str)
    }

    return <div className="mybtns_group">
        <div className="btn-group" role="group" aria-label="">
            <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-1")}>{menuTitleText}정보
            </button>
            <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-2")}>품목정보
            </button>
        </div>
        <div className="mybtns_group_toolbar"></div>
    </div>
}